<template>
  <div class="px-5">
    <strong>{{ label }}:</strong>
    <span
      v-if="!user"
      class="font-italic text--secondary ml-1"
      data-test="formatted-username"
      data-cy="formatted-username"
      >No user assigned</span
    >
    <span v-else data-test="formatted-username" data-cy="formatted-username">
      {{ formattedUsername }}
    </span>
    <div v-if="user" data-test="user-email">Email: {{ userEmail }}</div>
  </div>
</template>

<script>
export default {
  computed: {
    userEmail() {
      return this.user?.email || "";
    },
    formattedUsername() {
      if (!this.user) return "";
      return `${this.user.firstName} ${this.user.lastName}`;
    },
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    user: {
      type: Object,
      default: null,
    },
  },
};
</script>
